import SessionController from "./controllers/SessionController";
import SentinelController from "./controllers/SentinelController";
import AlarmsController from "./controllers/AlarmsController";
import PatientController from "./controllers/PatientController";
import TraceController from "./controllers/TraceController";
import CaringController from "./controllers/CaringController";
import UsersController from "./controllers/UsersController";
import SensorController from "./controllers/SensorController";
import SystemSettingController from "./controllers/SystemSettingController";
import GenericLogController from "./controllers/GenericLogController";
import NotificationController from "./controllers/NotificationController";
import TestAlarmController from "./controllers/TestAlarmController";

const ApiService = {
  SessionController,
  SentinelController,
  AlarmsController,
  PatientController,
  TraceController,
  SystemSettingController,
  CaringController,
  UsersController,
  SensorController,
  GenericLogController,
  NotificationController,
  TestAlarmController,
};
if (window.location.href.includes("localhost")) {
  (window as any)["ApiService"] = ApiService;
}
export default ApiService;
